module.exports = __webpack_public_path__ + "static/img/what-is-phyto-tech.0dbed042.png";